import { render } from "./vPart.vue?vue&type=template&id=0b89228d&scoped=true"
import script from "./vPart.vue?vue&type=script&lang=js"
export * from "./vPart.vue?vue&type=script&lang=js"

import "./vPart.vue?vue&type=style&index=0&id=0b89228d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b89228d"]])

export default __exports__